<template>
	<div>
		<CModal title="Ajouter une raison de litige" size="lg" :show.sync="showModal">
			<form ref="addForm" action="/api/complaint_reasons" method="POST" axiosMethod="post">
				<FormContent v-if="showModal" key="add" />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.addForm)">Ajouter</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import FormContent from './ComplaintReasonForm';

	export default {
		components: {
			FormContent,
		},
		data() {
			return {
				showModal: false,
			};
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 201 || res.status === 200) {
						this.$toast.success('Nouvelle raison créée avec succès !');
						this.showModal = false;
						this.$emit('refresh');
					}
				});
			},
		},
	};
</script>
